import { useQuery } from '@tanstack/react-query';

import { DATA_INIT_CACHING } from '@/configs/query';
import { API_CACHE_KEYS } from '@/features/api/constants/cache';
import { useGrapevineSuggestionApi } from '@/features/api/hooks/grapevine-suggestion/useGrapevineSuggestionApi';

export const useGetSuggestionCategories = () => {
  const api = useGrapevineSuggestionApi();
  return useQuery({
    queryKey: [API_CACHE_KEYS.SUGGESTION_CATEGORIES],
    queryFn: () => api.getSuggestionCategories(),
    ...DATA_INIT_CACHING
  });
};
